var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ibox theme"},[_c('div',{staticClass:"ibox-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('cms.site.theme.title')))])]),_vm._v(" "),_c('div',{staticClass:"ibox-content p-md"},[_c('LogoAndBanner'),_vm._v(" "),_c('div',{staticClass:"hr-line-dashed"}),_vm._v(" "),_c('CssVariables')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }